import addRecord from "app/api/requests/Records/addRecordRequest";
import delRecord from "app/api/requests/Records/delRecordRequest";
import editRecord from "app/api/requests/Records/editRecordRequest";
import getRecords from "app/api/requests/Records/getRecordsRequest";

export default {
  addRecord,
  delRecord,
  editRecord,
  getRecords
};
